<template>
  <BaseAutoCompleteWithMultipleSelectedItems
    v-model="modelValue"
    label="運営会社"
    itemName="name"
    :items="items"
    :management-office="props.managementOffice"
    :errorMessages="props.errorMessages"
  />
</template>
<script setup lang="ts">
import BaseAutoCompleteWithMultipleSelectedItems from '@/components/AutoCompletes/BaseAutoCompleteWithMultipleSelectedItems.vue';
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';

const props = defineProps<{
  modelValue: getOperationOffice[];
  managementOffice?: getManagementOffice;
  errorMessages?: string[];
}>();

const emit = defineEmits(['update:modelValue']);

const items = ref<getOperationOffice[]>([]);

onMounted(() => {
  Api()
    .autoCompleteOperationOffices()
    .then((data) => {
      items.value = data;
    });
});

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>
